import { generateSourcesForPicture, Picture } from '@farmersdog/corgi-x';
import styles from './WsavaLogo.module.css';

import WsavaLogoPngMobile from '../wsava-logo-mobile.png';
import WsavaLogoWebpMobile from '../wsava-logo-mobile.webp';
import WsavaLogoWebpDesktop from '../wsava-logo-desktop.webp';
import WsavaLogoPngDesktop from '../wsava-logo-desktop.png';
import { useId } from 'react';

const WsavaLogoMobileSources = {
  webp: WsavaLogoWebpMobile,
  png: WsavaLogoPngMobile,
};

const WsavaLogoDesktopSources = {
  webp: WsavaLogoWebpDesktop,
  png: WsavaLogoPngDesktop,
};

/**
 * Lazy loaded WSAVA logo.
 * Intended for use below the fold.
 */
export const WsavaLogo = () => {
  const id = useId();
  const wsavaLogoAssets = generateSourcesForPicture({
    desktopSources: WsavaLogoDesktopSources,
    mobileSources: WsavaLogoMobileSources,
  });

  return (
    <Picture
      key={id}
      loading="lazy"
      alt="WSAVA Global Veterinary Community  Logo"
      sources={wsavaLogoAssets}
      className={styles.root}
    />
  );
};
